import { ReactNode } from 'react';
import Image from 'next/image';

import { Box, List, ListItem } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { SanityImage } from '~/components/sanity-image';

import { PartnershipsTemplate } from '../model';

export type FooterBannerSectionProps = {
  ctaSlot?: ReactNode;
  title: string;
  partners: PartnershipsTemplate['partners'];
};

export function FooterBannerSection({ ctaSlot, title, partners }: FooterBannerSectionProps) {
  return (
    <Box
      as='section'
      bgGradient='linear(180deg, #1C206F, #040529)'
      overflow='hidden'
      position='relative'
      py={{
        base: 10,
        md: 20,
      }}
    >
      <BackgroundImage />
      <ContentContainer display='flex' flexDir='column' position='relative'>
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            fontWeight: 500,
            color: 'accent.sea-foam.500',
          }}
          headingProps={{
            size: 'marketing-4xl',
            color: 'white',
            textAlign: 'center',
            maxWidth: '860px',
            mx: 'auto',
            mb: 12,
          }}
        />
        <List display='flex' flexWrap='wrap' gap={6} justifyContent='center' mb={12}>
          {partners.map((partner) => {
            return (
              <ListItem key={partner._id} flex='0 1 262px'>
                <Card
                  alignItems='center'
                  backgroundColor='rgba(16, 19, 92, 0.80)'
                  border='none'
                  display='flex'
                  height='100px'
                  justifyContent='center'
                >
                  <SanityImage alt={partner.name} image={partner.logo} />
                </Card>
              </ListItem>
            );
          })}
        </List>
        {ctaSlot}
      </ContentContainer>
    </Box>
  );
}

function BackgroundImage() {
  return (
    <Box
      height='704px'
      left='50%'
      opacity='0.3'
      position='absolute'
      transform='translate(-50%, -50%)'
      width='2390px'
      top={{
        base: '50%',
        md: '20%',
      }}
    >
      <Image
        alt=''
        quality={100}
        sizes='2390px'
        src='/images/backgrounds/blue-lines-wide.png'
        style={{
          objectFit: 'cover',
          objectPosition: 'bottom',
        }}
        fill
      />
    </Box>
  );
}
